import { setWindowWidth, setIsBlur } from "../actions/ActionTypes";

interface initialStateInterface {
  windowWidth: number;
  isBlur: boolean;
}

const initialState: initialStateInterface = {
  windowWidth: window.innerWidth,
  isBlur: false,
};

function generalReducer(
  state = initialState,
  action: { type: string; payload: any }
) {
  switch (action.type) {
    case setWindowWidth:
      return { ...state, windowWidth: action.payload };

    case setIsBlur:
      return { ...state, isBlur: action.payload };

    default:
      return state;
  }
}

export default generalReducer;
